"use client";

import { useEffect } from "react";
import type { Product } from "@/app/data/products";
import { productToItem, trackViewItem } from "@/lib/analytics";

/**
 * Fires GA4 view_item + Pixel ViewContent once when the PDP mounts.
 * Keyed on product.id so client-side navigation between two PDPs emits
 * a fresh view (Next will remount the subtree when the route param flips).
 */
export function PdpAnalytics({ product }: { product: Product }) {
  useEffect(() => {
    trackViewItem(productToItem(product));
  }, [product.id]);
  return null;
}
